/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditDto } from '../../models/backend-credit-dto';
import { BackendCreditRequestDto } from '../../models/backend-credit-request-dto';

export interface FinancingSourcesCreditsUpdate$FormData$Params {
  /**
   * A unique integer value identifying this кредит.
   */
  id: number;
  body: BackendCreditRequestDto;
}

export function financingSourcesCreditsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditDto>;
    }),
  );
}

financingSourcesCreditsUpdate$FormData.PATH = '/api/financing_sources/credits/{id}/';
